import React from 'react';
import classNames from 'classnames';
import { CHOOSE_CLASS, DRAG_TEXT_CLASS, HIDDEN_CLASS, INSTRUCTIONS_CLASS } from './FileInputClasses';
import translations from './translations';

// IE11 and Edge do not support drop files on file inputs, so we've removed text that indicates that
const dropSupported =
  typeof navigator === 'object' && !/rv:11.0/i.test(navigator.userAgent) && !/Edge\/\d./i.test(navigator.userAgent);

const FileInputInstructions = ({
  files,
  multiple,
  className,
  id,
  altInstructionText,
  dragText,
  language = 'en',
}: {
  files: FileList | null;
  multiple?: boolean;
  className?: string;
  id?: string;
  altInstructionText?: string;
  dragText?: string;
  language?: 'en' | 'es';
}): JSX.Element => {
  const { defaultMultipleDragLabel, defaultSingleDragLabel, defaultAltInstructionLabel } = translations[language];
  return (
    <div id={id} className={classNames(className, INSTRUCTIONS_CLASS, { [HIDDEN_CLASS]: files })} aria-hidden="true">
      {dropSupported && (
        <span className={DRAG_TEXT_CLASS}>
          {dragText || (multiple ? defaultMultipleDragLabel : defaultSingleDragLabel)}
        </span>
      )}
      <span className={CHOOSE_CLASS}>{altInstructionText || defaultAltInstructionLabel}</span>
    </div>
  );
};

export default FileInputInstructions;
